/**
 * Module dependencies.
 */

import { TextField as MuiTextField } from '@mui/material';
import { color } from 'styles/utils/colors';
import styled from '@emotion/styled';

/**
 * Export `TextField` styled component.
 */

export const TextField = styled(MuiTextField)`
  & .MuiInputBase-input {
    font-size: 14px;
    opacity: 1;
  }

  & .MuiInputBase-input::placeholder {
    font-size: 14px;
    opacity: 1;
  }

  & input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 100px transparent inset;
    -webkit-text-fill-color: ${color('primary700')};
  }
`;
